(function clientHeatMap($, Adzuki)
{
	"use strict";

	var heatmap;
	var map;


	$(document).ready(function documentReady()
	{
		Adzuki.onload('Reports/clientHeatMap', function onload() {
			heatmap = new google.maps.visualization.HeatmapLayer({
				map: map
			});

			initMap();

			let zip    = $('#reportclientheatmap-zip').val();
			let radius = $('#reportclientheatmap-radius').val();

			Adzuki.Ajax.get('/Reports/getCoords/'+ zip + '/' + radius)
				.then(function populateTechnology(data) {
					const zipData = convertToHeatmapData(data);
					createHeatMap(zipData);
				});
		});

		function convertToHeatmapData(jsonData) {
			const heatmapData = jsonData.coords.map(coord => {
				return new google.maps.LatLng(parseFloat(coord.latitude), parseFloat(coord.longitude));
			});
			return heatmapData;
		}

		function createHeatMap(data)
		{
			heatmap.setData(data);
			heatmap.setMap(map);
		}

		function initMap()
		{
			let center = new google.maps.LatLng(39.8283, -98.5795);

			map = new google.maps.Map(document.getElementById('heat-map-container'), {
				center   : center,
				zoom     : 4,
				mapTypeId: 'hybrid'
			});
		}
	});
}(jQuery, window.Adzuki || {}));
